import React, { useState, useEffect } from "react";
import { FigureCard, CardHeader } from "@adeccoux/tag-ds";

const DisplayType2 = ({
    test,
    setnextDisable,
    phrases,
    selectedAns,
    setSelectedAns,
    selectedC,
    setExampleAns,
}) => {
    const chunk1 = test.questions[0].answers.slice(
        0,
        test.questions[0].answers.length / 2
    );
    const chunk2 = test.questions[0].answers.slice(
        test.questions[0].answers.length / 2,
        test.questions[0].answers.length
    );

    const [selectedC1, setselectedC1] = useState();

    useEffect(() => {
        if (selectedC > -1) {
            setselectedC1(-1);
        }
    }, [selectedC]);
    const handleChunks1 = (e) => {
        setselectedC1(e);
        setSelectedAns(e);
        setExampleAns(e);
        setnextDisable(false);
    };
    return (
        <>
            <div className="flex_col g1">
                <div className="caption">{phrases?.["1000258"]}</div>
                <div className="flex_row g2">
                    {chunk1.map((val, ind) => (
                        <FigureCard
                            key={ind}
                            onClick={() => handleChunks1(val.position)}
                            selected={val.position == selectedAns}
                        >
                            <CardHeader id="figure card header">
                                <h4
                                    dangerouslySetInnerHTML={{
                                        __html: val.content,
                                    }}
                                />
                            </CardHeader>
                        </FigureCard>
                    ))}
                </div>
            </div>
            <div className="flex_col g1">
                <div className="caption">{phrases?.["13424"]}</div>
                <div className="flex_row g2">
                    {chunk2.map((val, ind) => (
                        <FigureCard
                            key={ind}
                            onClick={() => handleChunks1(val.position)}
                            selected={val.position == selectedAns}
                        >
                            <CardHeader id="figure card header">
                                <h4
                                    dangerouslySetInnerHTML={{
                                        __html: val.content,
                                    }}
                                />
                            </CardHeader>
                        </FigureCard>
                    ))}
                </div>
            </div>
        </>
    );
};

export default DisplayType2;
